import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AdvMessageService } from 'shared/src/common';

@Component({
  selector: 'lib-swipe-card',
  templateUrl: './swipe-card.component.html',
  styleUrls: ['./swipe-card.component.scss']
})
export class SwipeCardComponent implements OnInit {
  swipe_buffer: string = "";
  swipe_timeout = null;
  SWIPE_TIMEOUT_MS = 100;


  constructor(public ref: DynamicDialogRef, private messagesService: AdvMessageService, private cd: ChangeDetectorRef,
  ) {

  }

  ngOnInit(): void {
    var self: any = this;
    try {
      if (typeof (window?.Kesher) != "undefined") {
        if (!window?.Kesher.version) {    
            window?.Kesher?.getCard("0");
            window?.Kesher?.getCard("1");   
        }

        else if (window?.Kesher.version() == 1) {      
          window?.Kesher?.setCard("1");
        }

      }
    }
    catch (error) {
    }

  }


  closeDialog() {
    if (typeof (window?.Kesher) != "undefined") {
      try {
        if (!window?.Kesher.version) {    
          window?.Kesher?.getCard("0");
      }

      else if (window?.Kesher.version() == 1) {      
        window?.Kesher?.setCard("0");
      }
       
      
      }
      catch (error) {
      }
    }
    this.ref.close(null);
  }
 
}








declare global {
  interface Window {
    Kesher: {
      onCard: (err: string | null, card?: string, exp?: string) => void
      getCard: (status: string) => void
      version: () => any
      setCard: (status: string) => void
      onMessage: (err: string | null, card?: string, exp?: string) => any,
      print: (details: string) => void,
      message: (event: any) => any,
      init: () => void
    }
  }
}

